export enum HomebaseStatusType {
  NotAvailable = 0,
  Available = 1,
}

export const GetHomebaseStatusType = [
  { Description: "Available", Value: HomebaseStatusType.Available },
  { Description: "Not Available", Value: HomebaseStatusType.NotAvailable },
];
